/**
 * Chunk-load / dynamic-import failures that the chunkReload guard auto-recovers
 * from by reloading the page. Painting the full "Algo salió mal" card for these
 * flashes an error that disappears a frame later, so we show a loader instead.
 */
export function isChunkLoadError(error: unknown): boolean {
  if (!error) return false;
  const name = error instanceof Error ? error.name : '';
  const message =
    error instanceof Error ? error.message : typeof error === 'string' ? error : '';
  const haystack = `${name} ${message}`;
  return (
    /ChunkLoadError/i.test(haystack) ||
    /Loading chunk/i.test(haystack) ||
    /dynamically imported module/i.test(haystack) ||
    /Failed to fetch dynamically imported/i.test(haystack) ||
    /import\(\)/i.test(haystack)
  );
}
